import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../../lib/router/withRouter';
import PageTemplate from '../../../components/template/PageTemplate';
import RecommendEventSaveContainer from '../../../containers/recommend/event/RecommendEventSaveContainer';
import { recommendEventActions } from '../../../store/modules/recommend/event';
import { _LIST_PAGINATION_MODEL } from '../../../store/modules/app/models';
import {
  RECOMMEND_EVENT_ITEM_LIST_FILTER_OPTION_MODEL,
  RECOMMEND_EVENT_SAVE_MODEL,
} from '../../../store/modules/recommend/event/models';
import { RECOMMEND_EVENT_PAGE_NAME } from '../../../constants/service/app/recommendEventConstants';

class RecommendEventCopy extends Component {
  componentDidMount() {
    const { match } = this.props;
    if (match.params.id) {
      this.initiate(Number(match.params.id));
    }
  }

  /**
   *  초기화
   */
  componentWillUnmount() {
    const { setData } = this.props;

    setData({
      path: ['recommendEventSave'],
      value: RECOMMEND_EVENT_SAVE_MODEL,
    });
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = (recommendEventId) => {
    const { prepareCopyRecommendEvent } = this.props;

    prepareCopyRecommendEvent({
      recommendEventId,
      /**
       *  검색 옵션
       */
      searchOption: RECOMMEND_EVENT_ITEM_LIST_FILTER_OPTION_MODEL,
      /**
       *  pagination
       */
      pagination: _LIST_PAGINATION_MODEL,
    });
  };

  render() {
    return (
      <PageTemplate pageName={RECOMMEND_EVENT_PAGE_NAME.RECOMMEND_EVENT_COPY}>
        <RecommendEventSaveContainer typeDisabled={true} />
      </PageTemplate>
    );
  }
}

const mapDispatchToProps = {
  setData: recommendEventActions.setData,
  prepareCopyRecommendEvent: recommendEventActions.prepareCopyRecommendEvent,
};

export default connect(null, mapDispatchToProps)(withRouter(RecommendEventCopy));
